import { __decorate } from "tslib";
import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { WebsiteThemeService } from '../../services/website-theme.service';
/**
 * Countdown Timer Component
 */
let CountdownTimerComponent = class CountdownTimerComponent {
    constructor(sanitizer, themeService, change) {
        this.sanitizer = sanitizer;
        this.themeService = themeService;
        this.change = change;
        this.expired = new EventEmitter();
        this.textColor = '';
        this.accentColor = '';
        this.timeIsUp = false;
        this.blink = false;
        this.borderRadiusSmaller = '';
        this.themeService.getTheme().subscribe((data) => {
            this.textColor = this.themeService.getStyleAttribute('text_color');
            this.accentColor = this.themeService.getStyleAttribute('accent_color');
            this.borderRadiusSmaller = this.themeService.getStyleAttribute('border_radius_smaller');
        });
    }
    ngOnInit() {
        if (typeof this.isTerminal !== 'undefined' && typeof this.blinkTime !== 'undefined' && typeof this.expiresAtUTC !== 'undefined') {
            this.setCounterTimeLeft();
        }
    }
    initialise(terminal, blinkTime, expires) {
        this.isTerminal = terminal;
        this.blinkTime = blinkTime;
        this.expiresAtUTC = expires;
        this.setCounterTimeLeft();
    }
    ngAfterViewInit() {
        this.counter.stop();
    }
    setCounterTimeLeft() {
        const currentTime = new Date().getTime();
        const res = (this.expiresAtUTC - currentTime / 1000);
        if (res <= 0) {
            if (this.isTerminal) {
                this.timeIsUp = true;
                this.expired.emit(true);
            }
        }
        else {
            if (typeof this.counter !== 'undefined') {
                this.change.detectChanges();
                this.counter.config.leftTime = parseInt(res + "");
                this.counter.config.notify = [this.blinkTime];
                this.blink = this.counter.config.leftTime <= this.blinkTime;
                this.counter.restart();
                this.expired.emit(false);
            }
        }
    }
    onFinishedCountdown() {
        if (this.isTerminal) {
            this.timeIsUp = true;
            this.expired.emit(true);
        }
        else {
            this.expired.emit(false);
        }
    }
    onTimetick() {
        this.blink = true;
    }
    handleEvent(event) {
        if (event.action === 'done') {
            this.onFinishedCountdown();
        }
        else if (event.action === 'notify') {
            this.onTimetick();
        }
    }
};
CountdownTimerComponent.ctorParameters = () => [
    { type: DomSanitizer },
    { type: WebsiteThemeService },
    { type: ChangeDetectorRef }
];
__decorate([
    ViewChild('countdown')
], CountdownTimerComponent.prototype, "counter", void 0);
__decorate([
    Output()
], CountdownTimerComponent.prototype, "expired", void 0);
__decorate([
    Input()
], CountdownTimerComponent.prototype, "isTerminal", void 0);
__decorate([
    Input()
], CountdownTimerComponent.prototype, "blinkTime", void 0);
__decorate([
    Input()
], CountdownTimerComponent.prototype, "expiresAtUTC", void 0);
CountdownTimerComponent = __decorate([
    Component({
        selector: 'ecd-countdown-timer',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./countdown-timer.component.html")).default
    })
], CountdownTimerComponent);
export { CountdownTimerComponent };
